/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtocopylink3Inputs */

const en_failedtocopylink3 = /** @type {(inputs: Failedtocopylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy link`)
};

const de_failedtocopylink3 = /** @type {(inputs: Failedtocopylink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link konnte nicht kopiert werden`)
};

/**
* | output |
* | --- |
* | "Failed to copy link" |
*
* @param {Failedtocopylink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtocopylink3 = /** @type {((inputs?: Failedtocopylink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtocopylink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtocopylink3(inputs)
	return de_failedtocopylink3(inputs)
});
export { failedtocopylink3 as "failedToCopyLink" }